import { useMutation } from '@tanstack/react-query';
import { ISaveJobPostDetailPayload } from '../types';
import { PermanentJobsService } from '../services';

export const useSaveJobPostDetail = () => {
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: Partial<ISaveJobPostDetailPayload> }) =>
      PermanentJobsService.saveJobPostDetail(id, payload),
  });
};
